import React from 'react';

import { nanoid } from '@reduxjs/toolkit';
import { NavLink } from 'react-router-dom';

import { bemCssModules, getTestId } from '@utils';

import style from './Menu.scss';

const cn = bemCssModules(style, 'Menu');
const ti = getTestId('Menu');

export type Tab = {
  label: string;
  link: string;
  hidden?: boolean;
  badge?: string;
  end?: boolean;
};

export type TMenu = {
  tabs: Tab[];
  onChange?: (tab: string) => void;
};

const Menu: CustomFC<TMenu> = props => {
  const { className, tabs, onChange } = props;

  const handleChange = (tab: string) => () => onChange?.(tab);

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('wrapper')}>
        <div className={cn('bottom-line')} />
        {tabs.map(({ link, label, badge, hidden, end }) => (
          <NavLink
            className={({ isActive }) => cn('link', { hidden, isActive }, ['link'])}
            key={nanoid()}
            data-testid={ti('link')}
            to={link}
            onClick={handleChange(label)}
            end={end}
          >
            {label}
            {badge && <span className={cn('badge')}>{badge}</span>}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default Menu;
